import { useMemo } from "react";
import { AddressElement } from "@stripe/react-stripe-js";
import { stripeElementsAddressElementModes } from "../../StripeElements/types";
import { useAddressElementAutocomplete } from "../../StripeElements/useAddressElementAutocomplete";
import { useAddressElementDefaultValues } from "../../StripeElements/useAddressElementDefaultValues";
import { useAddressElementDisplay } from "../../StripeElements/useAddressElementDisplay";
import { useAddressElementFields } from "../../StripeElements/useAddressElementFields";
import { useBillingInfoContext } from "./useBillingInfoContext";

export const AddressFields = () => {
  const {
    communityMemberBillingInfo,
    communityMember,
    setAddress,
    markAddressFieldsReady,
  } = useBillingInfoContext();

  const mode = stripeElementsAddressElementModes.billing;
  const defaultValues = useAddressElementDefaultValues({
    billingInfo: communityMemberBillingInfo,
    name: communityMember?.name,
  });
  const fields = useAddressElementFields();
  const display = useAddressElementDisplay();
  const autocomplete = useAddressElementAutocomplete();

  const options = useMemo(
    () => ({
      mode,
      defaultValues,
      fields,
      display,
      autocomplete,
    }),
    [mode, defaultValues, fields, display, autocomplete],
  );

  return (
    <div data-testid="stripe-address-element">
      <AddressElement
        options={options}
        onChange={setAddress}
        onReady={markAddressFieldsReady}
      />
    </div>
  );
};
